import React from 'react';

/**
 * PageHeader — encabezado estándar para todas las páginas.
 *
 * Props:
 *   title      string   — título principal (requerido)
 *   subtitle   string   — texto secundario debajo del título
 *   actions    node     — botones u otros elementos a la derecha
 *
 * Uso:
 *   <PageHeader
 *     title="Clientes"
 *     subtitle="Gestiona los clientes de la notaría"
 *     actions={<button className="btn btn-primary btn-sm">+ Nuevo</button>}
 *   />
 */
const PageHeader = ({ title, subtitle, actions }) => (
  <div style={{
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 22,
    flexWrap: 'wrap',
    gap: 12,
  }}>
    <div>
      <h4 style={{
        margin: 0,
        fontSize: 20,
        fontWeight: 700,
        color: '#111827',
        letterSpacing: '-0.3px',
        lineHeight: 1.3,
      }}>
        {title}
      </h4>
      {subtitle && (
        <p style={{
          margin: '3px 0 0',
          fontSize: 13,
          color: '#9CA3AF',
          fontWeight: 400,
        }}>
          {subtitle}
        </p>
      )}
    </div>
    {actions && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        {actions}
      </div>
    )}
  </div>
);

export default PageHeader;
